import React from 'react';
import { SectionHead } from './SectionHead';
import { ClockIcon } from './icons/ClockIcon';
import { ClockCircleOutlined } from '@ant-design/icons';

// S10: the dealer has not sent the documents yet
export const Waiting = ({ waiting }) => (
    <section id="waiting" className="card" aria-labelledby="waiting-title">
        <SectionHead id="waiting-title" icon={ClockCircleOutlined} title={waiting.title} sub={waiting.requested} />
        <ol className="stepper">
            {waiting.steps.map(step => (
                <li
                    className={`step${step.state ? ` ${step.state}` : ''}`}
                    aria-current={step.state === 'cur' ? 'step' : undefined}
                    key={step.label}
                >
                    <span className="step-dot" aria-hidden="true">
                        {step.n}
                    </span>
                    <span className="step-tx">
                        <span className="step-l">{step.label}</span>
                        <span className="step-s">{step.sub}</span>
                    </span>
                </li>
            ))}
        </ol>
        {/* "we'll email you, you can close this page" is for the screen; with nothing else to say the box stays out of
            the PDF (SC-QA-72) */}
        {(waiting.waitLine || waiting.note) && (
            <div className={`notice${waiting.waitLine ? '' : ' noprint'}`} data-testid="waiting-note">
                <ClockIcon />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {waiting.waitLine && <span style={{ fontWeight: 600 }}>{waiting.waitLine}</span>}
                    {waiting.note && (
                        <span className="noprint" style={{ fontSize: 14, color: 'var(--tokens-text-secondary)' }}>
                            {waiting.note}
                        </span>
                    )}
                </div>
            </div>
        )}
    </section>
);
